/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PatchedEvidenceArtefactSerialiser
 */
export interface PatchedEvidenceArtefactSerialiser {
  /**
   *
   * @type {number}
   * @memberof PatchedEvidenceArtefactSerialiser
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedEvidenceArtefactSerialiser
   */
  artefact?: string | null;
  /**
   *
   * @type {number}
   * @memberof PatchedEvidenceArtefactSerialiser
   */
  assessment?: number | null;
  /**
   *
   * @type {number}
   * @memberof PatchedEvidenceArtefactSerialiser
   */
  customAssessment?: number | null;
}

/**
 * Check if a given object implements the PatchedEvidenceArtefactSerialiser interface.
 */
export function instanceOfPatchedEvidenceArtefactSerialiser(value: object): value is PatchedEvidenceArtefactSerialiser {
  return true;
}

export function PatchedEvidenceArtefactSerialiserFromJSON(json: any): PatchedEvidenceArtefactSerialiser {
  return PatchedEvidenceArtefactSerialiserFromJSONTyped(json, false);
}

export function PatchedEvidenceArtefactSerialiserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedEvidenceArtefactSerialiser {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    artefact: json['artefact'] == null ? undefined : json['artefact'],
    assessment: json['assessment'] == null ? undefined : json['assessment'],
    customAssessment: json['custom_assessment'] == null ? undefined : json['custom_assessment'],
  };
}

export function PatchedEvidenceArtefactSerialiserToJSON(
  value?: Omit<PatchedEvidenceArtefactSerialiser, 'id'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    artefact: value['artefact'],
    assessment: value['assessment'],
    custom_assessment: value['customAssessment'],
  };
}
